// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._2rko12b0{border-radius:var(--ds-radius-small,4px)}._195gze3t{margin-inline:var(--ds-space-0,0)}\n._1moupxbi{margin-block:var(--ds-space-200,1pc)}\n._19bvpxbi{padding-left:var(--ds-space-200,1pc)}\n._19bvu2gc{padding-left:var(--ds-space-100,8px)}\n._1nmz1hna{word-break:break-word}\n._ca0qu2gc{padding-top:var(--ds-space-100,8px)}\n._n3tdu2gc{padding-bottom:var(--ds-space-100,8px)}\n._u5f3u2gc{padding-right:var(--ds-space-100,8px)}", ""]);
// Exports
module.exports = exports;
